import { useDatasourceId, useSeriesId } from '@/hooks';
import { useGetQueryRowsCountQuery } from '@/features/query-builder/queriesApiSlice';
import { useGetSavedQueryRowsCountQuery } from '@/features/query-builder/savedQueriesApiSlice';
import { useAppSelector } from '@/store/hooks';
import { selectFullResultsSeriesId } from '@/features/query-builder/queryBuilderSlice';
import { useLoadRows } from './useLoadRows';

export const useLoadRowsCount = (skip = false) => {
  const datasourceId = useDatasourceId();
  const seriesId = useSeriesId();
  const fullResultsSeriesId = useAppSelector(selectFullResultsSeriesId);

  const { data: rowsData } = useLoadRows();

  const rowsLoaded = !!rowsData?.dataTable?._rows;

  const shouldFetchRowCount =
    !(rowsData?.dataTable?._rows.length < 100) || !fullResultsSeriesId;

  const queryId = rowsData?.queryId;

  const shouldSkipQueryRowsCount =
    !queryId || !rowsLoaded || !shouldFetchRowCount;

  const shouldSkipSavedQueryRowsCount = !(
    seriesId &&
    rowsLoaded &&
    shouldFetchRowCount
  );

  const queryResult = useGetQueryRowsCountQuery(
    { datasourceId, queryId },
    { skip: shouldSkipQueryRowsCount || skip },
  );

  const savedQueryResult = useGetSavedQueryRowsCountQuery(
    { datasourceId, seriesId },
    { skip: shouldSkipSavedQueryRowsCount || skip },
  );

  if (!shouldFetchRowCount) {
    return {
      isSuccess: true,
      isFetching: false,
      data: { rowCount: rowsData?.dataTable?._rows.length },
    };
  }

  if (seriesId) return savedQueryResult;

  return queryResult;
};
